import React from 'react';
import PropTypes from 'prop-types';

import { isNonEmptyString, createCustomPropType } from '../../../js/app/react/validators';

import AdvWorkflow from '../AdvWorkflow/AdvWorkflowContainer';
import SchoolSelector from './Steps/SchoolSelectorContainer';
import SchoolTuition from './Steps/SchoolTuitionContainer';
import YearsSaving from './Steps/YearsSavingContainer';
import EnrollAge from './Steps/SchoolEnrollAgeContainer';
import ChildrenOverview from './Steps/ChildrenCRUDContainer';
import IsSpecificSchool from './Steps/IsSpecificSchoolContainer';
import SchoolSearch from './Steps/SchoolSearchContainer';
import TuitionType from './Steps/TuitionTypeContainer';

const ChildInfoWorkflow = ({
  branch,
  workflowId,
}) => (
  <AdvWorkflow
    branch={branch}
    workflowId={workflowId}
    steps={[
      ChildrenOverview,
      EnrollAge,
      IsSpecificSchool,
      SchoolSearch,
      TuitionType,
      SchoolSelector,
      SchoolTuition,
      YearsSaving,
    ]}
  />
);

ChildInfoWorkflow.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
};

export default ChildInfoWorkflow;
